export function beforeEnterFeatureFlagged(
  features: Parameters<typeof hasFeatureFlag>[0]
) {
  return () => (hasFeatureFlag(features) ? true : "/");
}
